import Coordinates from './Coordinates';
import PrayerTimes from './PrayerTimes';
import Prayer from './Prayer';
import { Madhab } from './Madhab';
import HighLatitudeRule from './HighLatitudeRule';
import CalculationMethod from './CalculationMethod';
import CalculationParameters from './CalculationParameters';
import Qibla from './Qibla';
import SunnahTimes from './SunnahTimes';
import { PolarCircleResolution } from './PolarCircleResolution';

const adhan = {
    Prayer,
    Madhab,
    HighLatitudeRule,
    Coordinates,
    CalculationParameters,
    CalculationMethod,
    PrayerTimes,
    SunnahTimes,
    Qibla,
    PolarCircleResolution,
};

export default adhan;